import * as Yup from "yup";

export const FORM_STEP = {
  info: "info",
  address: "address",
};

export const REGISTER_TYPE = {
  DOMESTIC: "DOMESTIC",
  OTHER: "OTHER",
};

export const REGISTER_DOCUMENT = {
  CITIZENID: "ID_CARD",
  PASSPORT: "PASSPORT_Id",
};

export const singUpInitialValues = {
  registerType: REGISTER_TYPE.DOMESTIC,
  idCardType: REGISTER_DOCUMENT.CITIZENID,
  companyName: "",
  businessType: null,
  numberOfEmployees: null,
  name: "",
  surName: "",
  email: "",
  phoneNo: {
    mobileNumber: "",
    mobileCodeId: "",
  },
  agreeTermsAndCond: false,
  // companyTypeDesc: ""
};

export const addressInitialValues = {
  address: null,
  province: null,
  district: null,
  subDistrict: null,
  postalCode: null,
};

const SignUpSchema = Yup.object().shape({
  registerType: Yup.string(),
  companyName: Yup.string().when("registerType", {
    is: (val) => val === REGISTER_TYPE.OTHER,
    then: () => Yup.string().required("Please enter company name."),
    otherwise: () => Yup.string().notRequired(),
  }),
  businessType: Yup.string().required(
    "Please select the business type of your company."
  ),
  // companyTypeDesc: Yup.string().when("registerType", {
  //   is: (val) => val === REGISTER_TYPE.OTHER,
  //   then: () => Yup.string().required("Please enter company type description."),
  //   otherwise: () => Yup.string().notRequired(),
  // }),
  numberOfEmployees: Yup.number()
    .min(1, "Invalid Number of Employee")
    .required("Please input number of employees in your company."),
  name: Yup.string().required("Please enter your name."),
  surName: Yup.string().required("Please enter your surname."),
  email: Yup.string()
    .email("Invalid email")
    .required("Please enter your email"),
  phoneNo: Yup.object().shape({
    mobileNumber: Yup.string()
      .min(9, "Invalid Phone No.")
      .max(12, "Invalid Phone No.")
      .required("Please enter your Phone No."),
    mobileCodeId: Yup.string().required("Please select your Phone country."),
  })
  // ,
  // idCardNumber: Yup.string().when("idCardType", {
  //   is: (val) => val === REGISTER_DOCUMENT.CITIZENID,
  //   then: () => Yup.string().required("Please select your Identifiation No."),
  //   otherwise: () => Yup.string().required("Please select your Passport No."),
  // }),
});

export const SignUpAddressSchema = Yup.object().shape({
  address: Yup.string().required("Please enter your company address detail."),
  province: Yup.string().required("Please select your company province."),
  district: Yup.string().required("Please select your company district."),
  subDistrict: Yup.string().required(
    "Please select your company sub-district."
  ),
  postalCode: Yup.number()
    .min(10000, "Invalid postal code.")
    .max(99999, "Invalid postal code.")
    .required("Please select your company postal code."),
});

export default SignUpSchema;
